import { INBOUND } from 'constants/messageDirection';
import { ACCOUNT_USER } from 'constants/roles';
import { makeGraphQLAllPagesRequest, makeGraphQLRequest } from 'graphql/makeGraphQLRequest';
import {
  FETCH_LAST_CUSTOMER_MESSAGE_QUERY,
  FETCH_MESSAGES_IN_CONVERSATION_FOR_ADMIN_QUERY,
  FETCH_MESSAGES_IN_CONVERSATION_QUERY,
} from './message.gql';
import { isUserAnAdmin, isAssignedExpert } from '../../user';
import AuthService from 'services/authService';

export const fetchConversationMessages = async (conversationId, isFlowDebugStateEnabled = false, simplrAccountId) => {
  const isAdmin = await isUserAnAdmin();
  const isCurrentConversationExpert = await isAssignedExpert(conversationId);
  const isAccountUser = AuthService.current()?.roles?.includes(ACCOUNT_USER);

  const shouldUseAdminQuery = isAdmin || isCurrentConversationExpert || isAccountUser;

  const SCHEMA = shouldUseAdminQuery
    ? FETCH_MESSAGES_IN_CONVERSATION_FOR_ADMIN_QUERY(isFlowDebugStateEnabled)
    : FETCH_MESSAGES_IN_CONVERSATION_QUERY;

  const filter = {
    conversationId: {
      eq: conversationId,
    },
  };
  if (simplrAccountId) {
    filter.simplrAccountId = { eq: simplrAccountId };
  }

  return makeGraphQLAllPagesRequest(
    SCHEMA,
    {
      filter,
      sorting: [
        {
          field: 'createdAt',
          direction: 'ASC',
        },
      ],
      paging: { first: 200 },
    },
    'messagesFind'
  );
};

export const fetchLastCustomerMessage = (conversation) => {
  const simplrAccountId = conversation.simplrAccountPtrId || conversation.simplrAccountId;
  const filter = {
    conversationId: {
      eq: conversation.objectId,
    },
    direction: {
      eq: INBOUND,
    },
  };
  if (simplrAccountId) {
    filter.simplrAccountId = { eq: simplrAccountId };
  }

  return makeGraphQLRequest(
    FETCH_LAST_CUSTOMER_MESSAGE_QUERY,
    {
      filter,
      sorting: [
        {
          field: 'createdAt',
          direction: 'DESC',
        },
      ],
    },
    'messageFindFirst'
  );
};
